import { Grid } from "@mui/material";
import React from "react";
import { Activity } from "../components/Activity/Activity";
import { ActivityRoot } from "../components/Activity/ActivityRoot";



export const Chat: React.FC = () => {


    return (
        <>
            <h1>TEST</h1>
            <Grid container>
                <Grid item xs={8}></Grid>
                <Grid item xs={4}>



                </Grid>
            </Grid>
        </>
    )
}